import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import blue from '@material-ui/core/colors/blue';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { t } from 'i18next';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AutoSuggest from '../../../../sharedComponents/AutoSuggest';

import { config } from '../../../base/models/Config';
import { user } from '../../../userManagement/models/User';
import { IDealer } from '../../models/Dealer/interface';
import { IUser } from '../../models/User';

const useStyles = makeStyles((theme: Theme) => createStyles({
  menuListNav: {
    maxHeight: '400px',
    overflowY: 'auto'
  },
  menuItemNav: {
    color: '#fff',
    fontSize: '0.8em',
    padding: '10px 25px'
  },
  menuListDialog: {
    overflowY: 'auto',
    padding: '0px'
  },
  menuItemDialog: {
    borderBottom: '2px solid rgba(0, 0, 0, 0.08)',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9em'
    }
  },
  divider: {
    backgroundColor: theme.palette.primary.contrastText
  },
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
    marginRight: theme.spacing(2)
  },
  card: {
    display: 'flex',
    margin: '10px',
    '&:hover': {
      cursor: 'pointer',
      boxShadow: '0px 1px 3px 3px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)'
    }
  },
  details: {
    display: 'flex',
    flexDirection: 'column'
  },
  content: {
    flex: '1 0 auto'
  },
  textField: {
    '& > label': {
      paddingLeft: 10,
      color: 'white !important'
    },
    '& svg': {
      color: 'white'
    },
    '& > MuiOutlinedInput-root.Mui-disabled': {
      color: 'blue',
      '& > fieldset': {
        borderColor: 'orange'
      }
  }
  }
}));

interface IProps {
 onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent> | React.ChangeEvent<{}>) => void;
 onMouseLeave?: () => void;
 onMouseEnter?: () => void;
 origin: 'navbar' | 'dialog';
 dark?: boolean;
}

export default ({origin, onClick, onMouseEnter, onMouseLeave, dark = false}: IProps, dealer: IDealer) => {
  const { t } = useTranslation();
  const { dealers } = (user as IUser);
  const classes = useStyles();

  const [searchString, setSearchString] = useState('');

  const choseDealer = (ev: React.MouseEvent<HTMLElement, MouseEvent> | React.ChangeEvent<{}>, dealer: IDealer) => {

    if (user !== null) {
      user.setDealer(dealer.id);
      user.hideDealerDialog();
      user.hideB2CDealerDialog();
      user.hideSignInDialog();
      user.hideB2CSignInDialog();
    }

    if (typeof onClick !== 'undefined') {
      onClick(ev);
    }
  };

  const handleSelect = (dealer : IDealer) => {
    user.chooseDealer(dealer);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setSearchString(event.target.value.toString().toLowerCase());
    user.getFilteredDealerList(searchString);
  };

  return (
    <div>
    <AutoSuggest
      label={t('Search Dealers')}
      suggestions={user.getFilteredDealerList(searchString)}
      onSelect={handleSelect}
      onChange={handleChange}
      className={dark ? classes.textField : undefined}
     />
    <MenuList className={origin === 'dialog' ? classes.menuListDialog : classes.menuListNav}>
      {origin === 'dialog' ?
      dealers.sort((a, b) => a.name.localeCompare(b.name)).map((dealer: IDealer) => (
        <Card
          key={dealer.id}
          className={classes.card}
          onClick={ev => choseDealer(ev, dealer)}
        >
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant='body1'>
                {dealer.name}
              </Typography>
              <Typography variant='subtitle1' color='textSecondary'>
                {dealer.customerAccount}
              </Typography>
            </CardContent>
          </div>
        </Card>
      ))
      :
      dealers.sort((a, b) => a.name.localeCompare(b.name)).map((dealer: IDealer) => (
        <MenuItem
          onMouseLeave={onMouseLeave}
          onMouseEnter={onMouseEnter}
          className={classes.menuItemNav}
          key={dealer.id}
          onClick={ev => choseDealer(ev, dealer)}
        >
          {dealer.customerAccount} : {dealer.name}
        </MenuItem>
      ))}
    </MenuList>
    </div>
  );
};
